<template>
  <div v-if="message.user == this.$root.user.uid" class="message mine" :class="{ first: !continuedMessage, continued: continuedMessage }">
    <span class="time" v-if="showWhen">{{ dateFormat(message.createdAt, 'h:MMtt') }}</span>
    <span class="date" v-if="showWhen">{{ dateFormat(message.createdAt, 'ddd dS mmm') }},</span>

<!--     <div class="author" v-if="!finalMessage">
      <span class="author-name">{{ from.firstname }}:</span>
      <img :src="from.profileimg" class="image-circle">
    </div> -->

    <img :src="from.profileimg" class="image-circle">

    <p class="bubble">
      <span class="author">{{ from.firstname }}:</span>
        {{ message.content }}
    </p>
  </div>

  <div v-else class="message notmine" :class="{ first: !continuedMessage, continued: continuedMessage }">
    <span class="date" v-if="showWhen">{{ dateFormat(message.createdAt, 'ddd dS mmm') }},</span>
    <span class="time" v-if="showWhen">{{ dateFormat(message.createdAt, 'h:MMtt') }}</span>
    
<!--     <div class="author" v-if="!finalMessage">
      <span class="author-name">{{ from.firstname }}:</span>
      <img :src="from.profileimg" class="image-circle">
    </div> -->

    <img :src="from.profileimg" class="image-circle">

    <p class="bubble">
      <span class="author">{{ from.firstname }}:</span>
        {{ message.content }}
    </p>
  </div>
  
</template>
<!-- <template>
  <div v-if="message.user == this.$root.user.uid" class="message mine">
    <span class="time">{{ moment(message.createdAt).format('h:m A') }}</span>
    <span class="date">{{ moment(message.createdAt).format('D MMM YYYY') }}</span>
    <p class="bubble">{{ message.content }}</p>
    <div class="author">
      <span class="author-name">{{ from.firstname + ' ' + from.surname }}</span>
      <img :src="from.profileimg" class="image-circle">
    </div>
  </div>
  <div v-else class="message">
    <span class="date">{{ moment(message.createdAt).format('D MMM YYYY') }}</span>
    <span class="time">{{ moment(message.createdAt).format('h:m A') }}</span>
    <p class="bubble">{{ message.content }}</p>
    <div class="author">
      <img :src="from.profileimg" class="image-circle">
      <span class="author-name">{{ from.firstname + ' ' + from.surname }}</span>
    </div>
  </div>
</template> -->

<script>
import { db } from '@/firebase'
var dateFormat = require('dateformat')

export default {
  name: 'Message',
  props: ['message', 'index', 'allmessages'],
  data () {
    return {
      dateFormat: dateFormat
    }
  },
  firebase () {
    return {
      from: {
        source: db.ref('users/' + this.message.user),
        asObject: true
      }
    }
  },
  computed: {
    continuedMessage () {
      if (this.allmessages[this.index - 1]) {
        if (this.allmessages[this.index - 1].user === this.message.user) {
          return true
        }
      } else {
        return false
      }
    },
    finalMessage () {
      if (this.allmessages[this.index + 1]) {
        if (this.allmessages[this.index + 1].user === this.message.user && !this.continuedMessage) {
          return true
        }
      } else {
        return false
      }
    },
    showWhen () {
      // Hide date if message is sent within the last 15 mins
      let now = Date.now()
      let diff = now - this.message.createdAt
      if (diff < 900000) {
        return false
      } else if (this.continuedMessage) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Message.vue?d570c4ae